import { AI_MESSAGE_ROLES } from '@highlight-cp/constants';

import type { AiChatMessagePart } from '../../ai-chat-types';
import { isImagePart } from '../../ai-chat-window-image';
import type { RenderPartContext } from '../types';

export const defaultIsPartVisible = (part: AiChatMessagePart, ctx: RenderPartContext): boolean => {
  if (part.type === 'text') {
    if (ctx.isStreaming && ctx.message.role === AI_MESSAGE_ROLES.ASSISTANT) {
      return false;
    }

    return (part.text?.trim().length ?? 0) > 0;
  }

  if (isImagePart(part)) {
    return true;
  }

  if (part.type.startsWith('data-')) {
    return false;
  }

  if (part.type.startsWith('tool-')) {
    return false;
  }

  return false;
};
